<script setup>
import { computed } from 'vue'
import { t, message } from '../lib/i18n.mjs'
import AppIcon from './AppIcon.vue'
const props = defineProps({ run: Object, submission: Object, busy: Boolean, ready: Boolean })
defineEmits(['run'])
const actions = [
  { id: 'initial', label: '构建初始图', hint: '拆分 Markdown，构建段落图与段内单元图，提取实体及向量' },
  { id: 'schema', label: '更新 Schema', hint: '按变更的节点和关系定义更新受影响数据' },
  { id: 'facets', label: '更新 Facet', hint: '只更新新增或修改的属性列，并汇总到段落' },
  { id: 'motifs', label: '更新 Motif', hint: '匹配新增或修改的子图模式' },
]
const task = computed(() => props.submission || props.run)
const operation = computed(() => task.value?.operation || task.value?.request?.operation)
const active = computed(() => ['submitting', 'queued', 'running'].includes(task.value?.status))
const failed = computed(() => ['failed', 'interrupted'].includes(task.value?.status))
const detail = computed(() => {
  if (failed.value)
    return `${t(task.value?.status === 'interrupted' ? '已中断' : '分析失败')} · ${message(task.value?.error || task.value?.progress?.stage || '')}`
  if (task.value?.status === 'completed') return t('已完成')
  if (task.value?.status === 'queued') return t('等待执行…')
  if (task.value?.status === 'submitting') return t('正在提交任务…')
  return message(task.value?.error || task.value?.progress?.stage || '正在分析…')
})
</script>
<template>
  <section class="analysis-bar" :aria-label="t('论证分析')">
    <div v-for="action in actions" :key="action.id" class="analysis-action" :data-operation="action.id">
      <button
        class="subtle-button"
        :disabled="busy || (action.id === 'initial' ? ready : !ready)"
        :title="operation === action.id ? detail : t(action.hint)"
        :aria-busy="active && operation === action.id"
        @click="$emit('run', action.id)"
      >
        <AppIcon v-if="active && operation === action.id" name="LoaderCircle" :size="12" />{{
          t(action.label)
        }}
      </button>
      <div
        v-if="operation === action.id"
        class="analysis-progress"
        :class="{ 'is-failed': failed }"
        :title="detail"
      >
        <div class="analysis-progress-text" role="status" aria-live="polite">
          <span>{{ detail }}</span
          ><span v-if="active && task?.progress?.total"
            >{{ task.progress.done }} / {{ task.progress.total }}</span
          >
        </div>
        <progress
          v-if="active"
          :value="task?.progress?.total ? task.progress.done / task.progress.total : undefined"
          max="1"
        />
      </div>
    </div>
  </section>
</template>
